import { HStack, Text } from '@chakra-ui/react';

import TextWithClipboard from '../TextWithClipboard';

interface DetailsRowProps {
  label: string;
  value: string;
  showClipboard?: boolean;
  valueTextStyle?: string;
}

function DetailsRow({
  label,
  value,
  showClipboard = true,
  valueTextStyle = 'smallRegular',
}: DetailsRowProps) {
  return (
    <HStack
      justify="space-between"
      align="center"
      py="16px"
      px="20px"
      borderRadius="md"
      bg="gray.50"
      w="full"
      borderBottom="1px solid"
      borderBottomColor="gray.200"
    >
      <Text textStyle="h6SemiBold" color="gray.700">
        {label}
      </Text>
      {showClipboard ? (
        <TextWithClipboard truncate={false} value={value} textStyle={valueTextStyle} />
      ) : (
        <Text textStyle={valueTextStyle} color="brand.mutedPurple">
          {value}
        </Text>
      )}
    </HStack>
  );
}

export default DetailsRow;
